import { Component, Inject, OnInit } from '@angular/core';
import { EmpresasService } from '../../../services/empresas.service';
import { HelpersService } from '../../../services/tools/helpers.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-eliminar-empresa-modal',
  templateUrl: './eliminar-empresa-modal.component.html',
  styleUrls: ['./eliminar-empresa-modal.component.scss']
})
export class EliminarEmpresaModalComponent implements OnInit {

  public errors: any = {};

  constructor(
    private service: EmpresasService,
    private helperService: HelpersService,
    public dialogRef: MatDialogRef<EliminarEmpresaModalComponent>,
    @Inject (MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }

  public aceptar(){
    console.log("ID: ",this.data);
    this.service.delete(this.data.id)
      .subscribe(response => {
        const respuesta = response.json();
        if (respuesta.success) {
          this.helperService.notification('Empresa eliminada', 'Se ha borrado exitosamente', 'success');
          //Poner dentro del success response
          this.dialogRef.close({eliminar:true});
          setTimeout(() => {window.location.reload()},3000);
        }
      }, error => {
        if(error.status == 400) {
          this.showServicesErrors(error.json().content);
        }else{
          this.dialogRef.close({eliminar:false});
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
        
        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error, false);
      });
  }
  public cerrar(){
    
    this.dialogRef.close({eliminar:false})
  }
  private showServicesErrors(errors:any[]){
    //Es posible que en algún momento se necesiten parsear los errores ya que las llaves del backend,
    //no correspondan con las llaves de los errores del front
    this.errors = errors;
  }
}



// WEBPACK FOOTER //
// ./src/app/administracion/empresas/eliminar-empresa-modal/eliminar-empresa-modal.component.ts